// Date labels shared by the homework pages.

const LOCALES = { fr: "fr-FR", en: "en-GB", ar: "ar-TN" };

export function localeFor(language) {
  return LOCALES[language] || language || "fr-FR";
}

function startOfDay(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

// Whole days from today to `value` (0 = today, negative = past).
export function daysUntil(value) {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return null;
  return Math.round((startOfDay(date) - startOfDay(new Date())) / 86400000);
}

export function isPast(value) {
  const date = value ? new Date(value) : null;
  return Boolean(date && !Number.isNaN(date.getTime()) && date.getTime() < Date.now());
}

// "lundi 2 novembre, 18:00"
export function formatDateTime(value, language) {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return "";
  const locale = localeFor(language);
  const day = date.toLocaleDateString(locale, {
    weekday: "long",
    day: "numeric",
    month: "long",
  });
  const time = date.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" });
  return `${day}, ${time}`;
}

// Short "due" badge text: today / tomorrow / in N days / passed.
export function dueBadge(value, tr) {
  const days = daysUntil(value);
  if (days === null) return null;
  if (isPast(value)) return { tone: "late", text: tr("dueIn.past") };
  if (days === 0) return { tone: "soon", text: tr("dueIn.today") };
  if (days === 1) return { tone: "soon", text: tr("dueIn.tomorrow") };
  return { tone: days <= 3 ? "soon" : "later", text: tr("dueIn.days", { count: days }) };
}

// <input type="datetime-local"> value from an ISO string.
export function toLocalInputValue(isoString) {
  const d = isoString ? new Date(isoString) : null;
  if (!d || Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
